import { I18n as I } from 'react-redux-i18n';
import { PartyTypes, AuctionStatuses, isFunc } from 'vdlib';

import { FilePdfOutlined } from '@ant-design/icons';

export const GridActionTypes = {
  StartAuction: 'StartAuction', //onClick: (auctionComponent) => auctionComponent.setState({ showDatePickerModal: true })
  EndAuctions: 'EndAuctions', //onClick:  (auctionComponent) => auctionComponent.props.selectAuction(auctionComponent.props.auction.ID, auctionComponent.props.auction.GarageID)
  AcceptAuction: 'AcceptAuction', //onClick:  (auctionComponent) => auctionComponent.props.acceptAuction(auctionComponent.props.auction.ID, auctionComponent.props.auction.GarageID)
  DispatchAuction: 'DispatchAuction', //onClick:  (auctionComponent) => auctionComponent.props.dispatchAuction(auctionComponent.props.auction.ID)
  CancelAuction: 'CancelAuction', //
  PrintAuctions: 'PrintAuctions', //
  PrintSelectedAuctions: 'PrintSelectedAuctions',
};

const getGridActions = (
  partyTypeDescription,
  auctionStatusDescription,
  callbacksObj,
  componentToBind
) => {
  let ga = {
    [`${PartyTypes.Operator}_${AuctionStatuses.Pending}`]: [
      {
        className: 'green',
        title: I.t('APPROVAL'),
        actionType: GridActionTypes.StartAuction,
      },
      {
        className: 'red',
        title: I.t('CANCELLATION'),
        actionType: GridActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`]: [
      {
        className: 'green',
        title: I.t('APPROVAL'),
        actionType: GridActionTypes.StartAuction,
      },
      {
        className: 'red',
        title: I.t('CANCELLATION'),
        actionType: GridActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Expert}_${AuctionStatuses.ForSelection}`]: [
      {
        className: 'blue',
        title: 'PDF',
        actionType: GridActionTypes.PrintAuctions,
      },
      {
        className: 'blue',
        title: 'PDF-Selected',
        actionType: GridActionTypes.PrintSelectedAuctions,
      },
    ],
    [`${PartyTypes.Insurance}_${AuctionStatuses.ForSelection}`]: [
      {
        className: 'green',
        title: I.t('SELECTION'),
        actionType: GridActionTypes.EndAuctions,
      },
      {
        className: 'blue',
        icon: <FilePdfOutlined />,
        title: 'PDF-Best',
        actionType: GridActionTypes.PrintAuctions,
      },
      {
        className: 'blue',
        title: 'PDF-Selected',
        actionType: GridActionTypes.PrintSelectedAuctions,
      },
    ],
    [`${PartyTypes.Insurance}_${AuctionStatuses.Finished}`]: [
      {
        className: 'blue',
        title: 'PDF',
        actionType: GridActionTypes.PrintAuctions,
      },
    ],
    [`${PartyTypes.Insurance}_${AuctionStatuses.ForDispatch}`]: [
      {
        className: 'blue',
        title: 'PDF',
        actionType: GridActionTypes.PrintAuctions,
      },
    ],
  };
  return (ga[`${partyTypeDescription}_${auctionStatusDescription}`] || []).map(
    a =>
      Object.assign({}, a, {
        onClick: isFunc(callbacksObj[a.actionType])
          ? callbacksObj[a.actionType].bind(componentToBind) // (isFunc(a.actionType.bind) ? a.actionType.bind(componentToBind) : a.actionType)
          : e => console.warn('no action wired up on button', e.target),
      })
  );
};

export default getGridActions;
